import type { SVGProps } from 'react';
import * as React from 'react';

const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/chevron-down">
      <path
        id="Icon"
        d="M19 8.8999L12 15.8999L5 8.8999"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default ChevronDownIcon;
